'use strict';

var base = require('ispu/product/pdpInstoreInventory');
var storeLocator = require('../storeLocator/storeLocator');
var utils = require('../utils');
var inputUtils = require('../components/input');
var cookie = require('../util/cookie');
var baseProduct = require('lyonscg/product/base');

var AGE_GATE_COOKIE_NAME = 'ageGateVerified';

/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement() {
    if ($('#inStoreInventoryModal').length !== 0) {
        $('#inStoreInventoryModal, .modal-backdrop').remove();
    }

    var headerText = $('.btn-get-in-store-inventory').data('modal-header-text') || null;

    let $isStoreLocatorRedesign = $('#isStoreLocatorRedesign');
    let redesignClassName = '';

    if (!headerText) {
        headerText = $('.cart-change-store').data('modal-header-text') || '';
    }

    if ($isStoreLocatorRedesign.length) {
        // setting class for Updated store modal
        redesignClassName = 'store-invetory-dialog-redesign';
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal" id="inStoreInventoryModal" role="dialog">'
        + '<div class="modal-dialog in-store-inventory-dialog ' + redesignClassName + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="h2">' + headerText + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal"></button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';

    $('body').append(htmlString);
    $('#inStoreInventoryModal').modal();
}

/**
 * Updates nearest store details in fullfillment options
 * @param {jQuery} response - response data
 * @param {boolean} afterChangeStoreClicked - if store is selected form change store modal
 */
function updateNearestStoreDetails(response, afterChangeStoreClicked) {
    var products = response.products;
    var $shippingOptions = $('.shipping-options-available');
    var $addToCartButton = $('button.add-to-cart');
    var $getStartedButton = $('#getting-started-btn');
    var $productContainerRedesign = $shippingOptions.closest('.product-detail');
    var selectedPid = baseProduct.getPidValue($productContainerRedesign);
    var correctVarientSelected = false;
    var indexOfColor = false;
    var updateColorValue = null;

    let $selectedShippingOption = $('#selectedShippingOption', $productContainerRedesign);

    if (products.length) {
        for (var i = 0; i < products.length; i++) {
            var product = products[i];
            var $input = $('input#storeDetail-' + product.id);

            if (product.nearestStoreDetailsObj && $shippingOptions.length) {
                var $inputData = $input.length ? $input : $('<input>', { type: 'hidden', id: 'storeDetail-' + product.id }).appendTo($shippingOptions);
                $inputData.data('json', JSON.stringify(product.nearestStoreDetailsObj));

                // updating the store data on change of store
                var varientPid = null;

                let $instoreDelivery = $('.instore-delivery', $shippingOptions);
                if ($instoreDelivery.length && selectedPid === product.id) {
                    varientPid = selectedPid;
                    $selectedShippingOption.data('storeId', product.nearestStoreDetailsObj.nearestStoreId);
                    $selectedShippingOption.data('inventory', product.nearestStoreDetailsObj.inventoryAvailable);
                }

                if (varientPid) {
                    var $varientStoreInput = $('input#storeDetail-' + varientPid);

                    if ($varientStoreInput.length) {
                        var storeObj = JSON.parse($varientStoreInput.data('json'));
                        var storeAddress = '';
                        storeAddress += storeObj.address1 ? storeObj.address1 : '';
                        storeAddress += storeObj.address2 ? storeObj.address2 : '';
                        storeAddress += storeObj.stateCode ? ', ' + storeObj.stateCode : '';
                        storeAddress += ' ' + storeObj.postalCode + '.';
                        var stockMsg = storeObj.limitedStockMessage ? storeObj.limitedStockMessage : '';
                        var $storePickupMsg = $('.product-store-pickup-message', $shippingOptions);

                        if (storeObj.nearestStoreText) {
                            // update based on nearest store message
                            $('.nearest-store-message', $shippingOptions).text(storeObj.nearestStoreText).removeClass('hide');
                            $('.default-store-text', $shippingOptions).addClass('hide');
                        } else {
                            $('.nearest-store-message', $shippingOptions).text('').addClass('hide');
                            $('.default-store-text', $shippingOptions).removeClass('hide');
                        }

                        var sName = storeObj.storeName ? storeObj.storeName.replace(' - GameStop', '') : 'Select a store';
                        $('.product-store-address', $shippingOptions).text(sName);
                        $shippingOptions.find('.instore-delivery .product-store-message').text(stockMsg);
                        if (storeObj.limitedStockMessage) {
                            $('.inStockInstore', $shippingOptions).addClass('hide');
                        } else {
                            $('.inStockInstore', $shippingOptions).removeClass('hide');
                        }

                        $('.store-unavailable-message', $shippingOptions).addClass('hide');
                        $('.outOfStockInstore', $shippingOptions).addClass('hide');
                        $('.unavailable-at', $shippingOptions).addClass('hide');
                        $('.product-store-address.change-store', $shippingOptions).removeClass('hide');
                        $('.product-store-address.change-store', $shippingOptions).data('store-id', storeObj.nearestStoreId);

                        if (!product.isBOPSPreOrder) {
                            if (storeObj.InStorePickUpMessageSameDay) {
                                $storePickupMsg.find('.same-day').removeClass('hide');
                                $storePickupMsg.find('.next-day').addClass('hide');
                                $storePickupMsg.find('.countdown-timer').text(storeObj.InStorePickUpMessageSameDay);
                                $storePickupMsg.removeClass('hide');
                                $('.pick-today', $shippingOptions).removeClass('hide');
                                $('.pick-tomorrow', $shippingOptions).addClass('hide');
                            } else if (storeObj.InStorePickUpMessageNextDay) {
                                $storePickupMsg.find('.next-day').removeClass('hide');
                                $storePickupMsg.find('.same-day').addClass('hide');
                                $storePickupMsg.find('.next-date').text(storeObj.InStorePickUpMessageNextDay);
                                $storePickupMsg.removeClass('hide');
                                $('.pick-today', $shippingOptions).addClass('hide');
                                $('.pick-tomorrow', $shippingOptions).removeClass('hide');
                            } else {
                                $storePickupMsg.addClass('hide');
                                $('.pick-today', $shippingOptions).removeClass('hide');
                                $('.pick-tomorrow', $shippingOptions).addClass('hide');
                            }
                        }

                        // Enabling add to cart button if store is available
                        if ($addToCartButton.attr('disabled')) {
                            $('.map-pricing-redesign').addClass('d-none');
                            $addToCartButton.removeAttr('disabled');

                            if ($addToCartButton.data('addText')) {
                                $addToCartButton.text($addToCartButton.data('addText'));
                            }
                        }

                        // Enabling get started button for XAA if store is available
                        if ($getStartedButton.attr('disabled')) {
                            $getStartedButton.removeAttr('disabled');
                        }
                    }
                }

                if (selectedPid === product.id) {
                    correctVarientSelected = true;
                } else if (!indexOfColor && product.variationAttributes && product.variationAttributes.color) {
                    indexOfColor = true;
                    updateColorValue = product.variationAttributes.color.toLowerCase();
                }
            } else if ($input.length) {
                $input.remove();
            } else if ($shippingOptions.length) {
                let storeData = response.storeName;

                if ($('input#defaultStore', $shippingOptions).length) {
                    $('input#defaultStore', $shippingOptions).val(storeData);
                } else {
                    $('<input>', { type: 'hidden', id: 'defaultStore', value: storeData }).appendTo($shippingOptions);
                }
            }
        }

        if (!correctVarientSelected && indexOfColor && afterChangeStoreClicked) {
            // updating selected color after store is selected from store modal
            var $colorSwatch = $('.color-value.swatch-value.selectable[data-attr-value=' + updateColorValue + ']', $productContainerRedesign);
            if ($colorSwatch.length) {
                $colorSwatch.trigger('click');
            }
        }
    }
}

/**
 * get store inventory for master product on page load
 * @param {boolean} afterChangeStoreClicked - if store is selected form change store modal
 * @returns {Object} defer object
 */
function getStoreInventoryAvailability(afterChangeStoreClicked, storeId) {
    var defer = $.Deferred(); // eslint-disable-line
    var $pickupButton = $('.btn-get-in-store-inventory');
    var $productContainer = $pickupButton.closest('.product-detail');
    var url = $pickupButton.data('get-preferred-store-inventory-url');

    var urlParams = {
        storeId: storeId
    };
    $('a.proceed').data('storeid', storeId);
    if (url && storeId) {
        url = utils.appendToUrl(url, urlParams);
    }

    var isMasterInStock = $('#isMasterInStock').val();
    var isStock = (isMasterInStock === 'true');
    var isSddOrBopsEligible = $('#isSddOrBopsEligible').val() === 'true';
    if (isStock && isSddOrBopsEligible && url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function (response) {
                if (response) {
                    if (response.storePickupDetails && (!response.storePickupDetails.hopsEnabled && !response.storePickupDetails.bopsEnabled && !response.storePickupDetails.ispuEnabled)) {
                        // store pickup not available at this store
                        $pickupButton.addClass('d-none');
                        $('.preferred-store-inventory-availability').removeClass('d-none').empty().html(response.storeAvailabilityHtml);
                    } else if (response.hasVariantsAvailableForPickup) {
                        // store pickup is available for at least 1 variant
                        $pickupButton.removeClass('d-none');
                        $('.preferred-store-inventory-availability').removeClass('d-none').empty().html(response.storeAvailabilityHtml);
                    } else if (response.hasVariantsAvailableForLookup) {
                        // hide store pickup button - no variants are available for pickup
                        $pickupButton.addClass('d-none');
                        $('.preferred-store-inventory-availability').removeClass('d-none').empty().html(response.storeAvailabilityHtml);
                    } else {
                        $pickupButton.addClass('d-none');
                        $('.preferred-store-inventory-availability').addClass('d-none');
                    }

                    var output = {};
                    output.storeId = response.storeId;
                    output.masterProductId = response.masterProductId;
                    output.hasCondition = response.hasCondition;
                    output.hasVariantsAvailableForLookup = response.hasVariantsAvailableForLookup;
                    output.hasVariantsAvailableForPickup = response.hasVariantsAvailableForPickup;
                    output.products = response.products || null;
                    output.variationAttributes = response.variationAttributes || null;
                    output.resources = response.resources || null;
                    output.storePickupDetails = response.storePickupDetails || null;
                    if (output.resources) {
                        output.resources.pickUpInStore = $('.pickup-at-store-label').val();
                    }

                    $('.product-store-pickup-data').data('json', JSON.stringify(output));

                    defer.resolve();

                    $('body').trigger('store:afterGetStoreAvailability', {
                        data: response,
                        container: $productContainer
                    });

                    updateNearestStoreDetails(response, afterChangeStoreClicked);

                    const storeContainer = $('.hide-store');
                    storeContainer?.removeClass('hide-store');
                }
            },
            error: function () {
                defer.reject();
            }
        });
    }
    return defer;
}

/**
 * Gets store pickup data from product html
 *
 * @returns {Object} the store pickup data object
 */
function getStorePickupData() {
    if ($('.btn-get-in-store-inventory').length === 0) {
        return null;
    }

    var data = $('.product-store-pickup-data').data('json');
    var storePickupData = null;
    if (data) {
        try {
            storePickupData = JSON.parse(data);
        } catch (ex) {
            storePickupData = null;
        }
    }

    return storePickupData;
}

/**
 * Replaces the content in the modal window with find stores components and
 * the result store list.
 * @param {string} pid - The product ID to search for
 * @param {number} quantity - Number of products to search inventory for
 * @param {number} selectedPostalCode - The postal code to search for inventory
 * @param {number} selectedRadius - The radius to search for inventory
 * @param {string} [selectedStore] - The currently selected store if pickup is selected
 */
function fillModalElement(pid, quantity, selectedPostalCode, selectedRadius, selectedStore) {
    if (!quantity) {
        quantity = 1; // eslint-disable-line no-param-reassign
    }

    let $isStoreLocatorRedesign = $('#isStoreLocatorRedesign');

    var products = [];
    var productIds = [];
    products.push(pid + ':' + quantity);
    productIds.push(pid);

    var hasCondition = false;
    var hasVariantsAvailableForLookup = false;
    var hasVariantsAvailableForPickup = false;
    var masterProductId = null;
    var storePickupData = getStorePickupData();
    if (storePickupData) {
        if (Object.hasOwnProperty.call(storePickupData, 'hasCondition')) {
            hasCondition = storePickupData.hasCondition;
        }
        if (Object.hasOwnProperty.call(storePickupData, 'hasVariantsAvailableForLookup')) {
            hasVariantsAvailableForLookup = storePickupData.hasVariantsAvailableForLookup;
        }
        if (Object.hasOwnProperty.call(storePickupData, 'hasVariantsAvailableForPickup')) {
            hasVariantsAvailableForPickup = storePickupData.hasVariantsAvailableForPickup;
        }
        if (Object.hasOwnProperty.call(storePickupData, 'masterProductId')) {
            masterProductId = storePickupData.masterProductId;
        }
        /**
         * if product has condition we need to get inventory for all variants
         * or if this product is the master product, get inventory for all variants
         *
         * change Jan 20-2023 - restrict to only the selected condition on the page.
         */
        if (hasCondition || String(masterProductId) === String(pid)) {
            var pickupProducts = storePickupData.products || [];
            if (pickupProducts.length) {
                for (var i = 0; i < pickupProducts.length; i++) {
                    var pickupProduct = pickupProducts[i];
                    if (productIds.indexOf(pickupProduct.id) === -1 && pickupProduct.id === pid) {
                        productIds.push(pickupProduct.id);
                        products.push(pickupProduct.id + ':' + quantity);
                    }
                }
            }
        }
    }

    var requestData = {
        products: products.join(','),
        productDetailsPID: pid,
        selectedStore: selectedStore
    };

    if (selectedRadius) {
        requestData.radius = selectedRadius;
    }

    if (selectedPostalCode) {
        requestData.postalCode = selectedPostalCode;
    }

    requestData.hasCondition = hasCondition || false;
    requestData.hasVariantsAvailableForLookup = hasVariantsAvailableForLookup || false;
    requestData.hasVariantsAvailableForPickup = hasVariantsAvailableForPickup || false;

    if ($isStoreLocatorRedesign.length) {
        $('#inStoreInventoryModal .store-invetory-dialog-redesign').spinner().start();
    } else {
        $('#inStoreInventoryModal').spinner().start();
    }

    $.ajax({
        url: $('.btn-get-in-store-inventory').data('action-url'),
        data: requestData,
        method: 'GET',
        success: function (response) {
            $('#inStoreInventoryModal .modal-body').empty();
            $('#inStoreInventoryModal .modal-body').html(response.storesResultsHtml);
            var sourceParam = utils.getQueryStringParams(response.queryString);
            var sourceIndex = sourceParam && Object.keys(sourceParam).indexOf('source');
            var source = Object.values(sourceParam)[sourceIndex];
            if (source === 'pdp') {
                $('body').trigger('pdp:storeSearchViewed');
            }
            storeLocator.search();
            storeLocator.changeRadius();
            storeLocator.selectStore();
            storeLocator.callStore();
            storeLocator.checkStoreHours();
            storeLocator.detectLocation();

            $('.btn-storelocator-search').attr('data-search-pid', pid);

            if (selectedRadius) {
                $('#radius').val(selectedRadius);
            }

            if (selectedPostalCode) {
                $('#store-postal-code').val(selectedPostalCode);
            }

            if (!$('.results').data('has-results')) {
                $('.store-locator-no-results').show();

                if ($('.store-locator-no-results-search').length) {
                    let dataZero = $('.store-locator-results-header .col').data('zero-stores');
                    $('.store-locator-results-header .col').addClass('text-right text-uppercase').html(dataZero);
                }
            }

            $('#inStoreInventoryModal').modal('show');

            if ($isStoreLocatorRedesign.length) {
                $('#inStoreInventoryModal .store-invetory-dialog-redesign').spinner().stop();
            } else {
                $('#inStoreInventoryModal').spinner().stop();
            }

            inputUtils.initInputLabels();
        },
        error: function () {
            if ($isStoreLocatorRedesign.length) {
                $('#inStoreInventoryModal .store-invetory-dialog-redesign').spinner().stop();
            } else {
                $('#inStoreInventoryModal').spinner().stop();
            }
        }
    });
}

/**
 * update session attribute for preferred store id
 * @param {string} url - set preferred store endpoint
 * @param {string} storeId - The store ID selected for in store pickup.
 * @param {string} source - the source
 */
function updatePreferredStore(url, storeId, source) {
    if (!url || !storeId) return;

    var requestData = {
        storeId: storeId,
        source: source || 'pdp'
    };
    var isStoreSheet = requestData.source === 'pdp' || requestData.source === 'plp';

    if (!isStoreSheet) {
        $.spinner().start();
    }
    $.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        data: requestData,
        success: function (data) {
            if (data.redirectUrl) {
                if (!isStoreSheet) {
                    var changeStoreClickedOption = $('.fullfillment-radio .cart-delivery-options .instore-delivery.change-store-clicked');
                    if (changeStoreClickedOption.length) {
                        $.spinner().stop();
                        changeStoreClickedOption.find('input.delivery-option').trigger('click', ['forOOS']);
                    }
                }
                window.location.href = utils.removeTrailingSlash(data.redirectUrl);
            } else if (!isStoreSheet) {
                $.spinner().stop();
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else if (!isStoreSheet) {
                $.spinner().stop();
            }
        }
    });
}


/**
 * Show Age Gate and continue with bops-action-url
 */
function processBopsPickup() {
    var $button = $('.btn-get-in-store-inventory');
    var productId = $button.closest('.product-detail').attr('data-pid');
    var storeId = $button.data('preferred-store-id');
    var inStockCount = $button.data('in-stock-count') || 1;
    var ageRestricted = $button.data('age-restricted');
    var clearBasketUrl = $button.data('clear-basket-url');
    var ageGateCookie = cookie.get(AGE_GATE_COOKIE_NAME);

    var placeBopsOrder = function () {
        $.spinner().start();
        $.get(clearBasketUrl, function () {
            var bopsUrl = $button.data('bops-action-url') + '?pid=' + productId + '&sid=' + storeId + '&inStockCount=' + inStockCount;
            $.get(bopsUrl, function (data) {
                if (data && data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                }
            }).always(function () {
                $.spinner().stop();
            });
        });
    };

    if (ageRestricted && ageGateCookie === undefined) {
        $('#age-gate-modal').modal('show');
        $('#age-gate-modal').on('click', '.17-or-older', function () {
            placeBopsOrder();
        });
    } else if (ageRestricted && ageGateCookie === false) {
        $('#age-gate-item-restricted-modal').modal('show');
    } else {
        placeBopsOrder();
    }
}

/**
 * Prepare store Data and show HOPS modal
 */
function processHopsPickup() {
    var $button = $('.btn-get-in-store-inventory');
    var productId = $button.closest('.product-detail').attr('data-pid');
    var storeId = $button.data('preferred-store-id');
    var hopsActionUrl = $button.data('hops-action-url');
    var inStock = $button.data('in-stock');

    $('body').trigger('store:storepickup-reserve', {
        data: {
            inStock: inStock,
            productId: productId,
            storeId: storeId,
            hopsActionUrl: hopsActionUrl
        }
    });
}

var exportBase = $.extend({}, base, {
    methods: {
        updateQuantityOptions: base.methods.updateQuantityOptions,
        getModalHtmlElement: getModalHtmlElement,
        updatePreferredStore: updatePreferredStore,
        getStorePickupData: getStorePickupData,
        fillModalElement: fillModalElement,
        getStoreInventoryAvailability: getStoreInventoryAvailability
    },
    updateSelectStore: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            $('body').trigger('store:afterGetStoreAvailability', {
                productId: response.product.id || null,
                container: response.$productContainer
            });
        });
    },
    updateAddToCartFormData: function () {
        $('body').on('updateAddToCartFormData', function (e, form) {
            var storeElement = $('.product-detail[data-pid="'
                + form.pid
                + '"]');

            if ($(storeElement).length) {
                // add store ID to form if this product is not available via web
                var availableOnline = $(storeElement).find('div.availability').data('available');
                if (!availableOnline) {
                    var $storePickUpButton = $(storeElement).find('.btn-get-in-store-inventory');
                    if ($storePickUpButton.length > 0) {
                        var storeId = $storePickUpButton.data('preferred-store-id');
                        var inStockCount = $storePickUpButton.data('in-stock-count');
                        var isInStock = $storePickUpButton.data('in-stock');
                        var storeInventoryCount = parseInt(inStockCount, 10);
                        if (storeId && isInStock) {
                            form.storeId = storeId; // eslint-disable-line no-param-reassign
                            form.storeInventoryCount = storeInventoryCount || 0; // eslint-disable-line no-param-reassign
                        }
                    }
                }
            }
        });
    },
    selectStoreWithInventory: function () {
        $('body').on('store:selected', function (e, data) {
            var storeID = data.storeID;
            var $storeInventoryButton = $('.btn-get-in-store-inventory');
            var conditionDetails = data.conditionDetails || null;
            var counterMax = 30;
            var counter = 0;
            var timeoutDelay = 500;
            var afterChangeStoreClicked = true;
            $('#inStoreInventoryModal .modal-dialog').css('opacity', 0.3);

            if (storeID && data.event && data.event.target && data.event.target.className && data.event.target.className.indexOf('select-store') > -1) {
                var selectCondition = function () {
                    var promise = new Promise(function (resolve) {
                        var $conditions = $('.attribute.form-group.condition-attribute .card-deck');
                        if ($conditions.length === 0 || !conditionDetails) {
                            resolve();
                        } else {
                            var conditionPid = conditionDetails.pid || null;
                            var conditionName = conditionDetails.condition || null;
                            var $conditionToSelect = $('[data-attr="condition"] [data-condition-selected-variant-id="' + conditionPid + '"]');
                            if (!$conditionToSelect.length) {
                                $conditionToSelect = $('[data-attr="condition"] [data-attr-value="' + conditionName + '"]');
                                if ($conditionToSelect.length > 0) {
                                    // change the condition PID if we found a match based on name, not PID
                                    conditionPid = $conditionToSelect.data('condition-selected-variant-id');
                                }
                            }
                            if ($conditionToSelect.length > 0) {
                                if (afterChangeStoreClicked) {
                                    $conditionToSelect.trigger('click', afterChangeStoreClicked);
                                } else {
                                    $conditionToSelect.trigger('click');
                                }

                                // set counter to prevent endless looping
                                counter = 0;
                                var waitForConditionClick = function () {
                                    var $selectedCondition = $conditions.find('.selected');
                                    var selectedVariantId = null;
                                    if ($selectedCondition.length > 0) {
                                        selectedVariantId = $selectedCondition.data('condition-selected-variant-id');
                                    }
                                    if (counter < counterMax && selectedVariantId !== conditionPid) {
                                        counter++;
                                        setTimeout(function () { waitForConditionClick(); }, timeoutDelay);
                                    } else {
                                        resolve();
                                    }
                                };
                                waitForConditionClick();
                            } else {
                                resolve();
                            }
                        }
                    });
                    return promise;
                };
                var retrieveStoreInventory = function () {
                    var promise = new Promise(function (resolve) {
                        getStoreInventoryAvailability(afterChangeStoreClicked, data.storeID);
                        setTimeout(function () { resolve(); }, timeoutDelay);
                    });
                    return promise;
                };
                var finishUp = function () {
                    var promise = new Promise(function (resolve) {
                        $('#inStoreInventoryModal').modal('hide');
                        $('#inStoreInventoryModal').remove();
                        if ($storeInventoryButton.length && !$storeInventoryButton.prop('disabled')) {
                            if (!$storeInventoryButton.data('bops-flag')) {
                                processHopsPickup();
                            }
                        }
                        resolve();
                    });
                    return promise;
                };

                selectCondition()
                    .then(retrieveStoreInventory)
                    .then(finishUp);
            }
        });
    },
    callStoreClicked: function () {
        $('body').on('store:callStore', function (e, data) {
            var storeID = data.storeID;
            var $storeInventoryButton = $('.btn-get-in-store-inventory');
            var productId = $('.product-detail').data('pid');
            var hopsActionUrl = $storeInventoryButton.data('hops-action-url');
            if (storeID && data.event && data.event.target && data.event.target.className && data.event.target.className.indexOf('call-store') > -1) {
                var params = {
                    productId: productId,
                    storeId: storeID,
                    hopsActionUrl: hopsActionUrl,
                    callStore: true
                };
                $('#inStoreInventoryModal').modal('hide');
                $('#inStoreInventoryModal').remove();
                $('body').trigger('store:storepickup-reserve', { data: params });
            }
        });
    },
    showInStoreInventory: function () {
        $('body').on('click', '.btn-get-in-store-inventory', (function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $button = $('.btn-get-in-store-inventory');
            var bopsFlag = $button.data('bops-flag');

            if (bopsFlag) {
                processBopsPickup();
            } else {
                processHopsPickup();
            }
        }));
    },
    changeStore: function () {
        $('body').on('click', '.store-header-container .change-store, .product-store-address.change-store, .instore-delivery .change-store', (function (e) {
            e.preventDefault();
            e.stopPropagation();

            $('body').trigger('product:beforeChangeStore');

            var pid = $(this).closest('.product-detail').data('pid');
            var selectedVariantPid = $(this).closest('.product-detail').data('selected-variant-pid');
            if (selectedVariantPid && String(selectedVariantPid) !== String(pid)) {
                pid = selectedVariantPid;
            }
            const selectedStoreID = $(this).closest('.product-store-address.change-store').data('store-id');
            var quantity = $(this).closest('.product-detail').find('.quantity-select').val();
            getModalHtmlElement();
            fillModalElement(pid, quantity, $(this).data('postal'), $(this).data('radius'), selectedStoreID);
        }));
    }
});

module.exports = exportBase;
